<template>
    <v-container grid-list px-10 pt-10 pb-4 class="co-papeis">
        <configuracoes-exclusivas :eh-sem-funcionalidade="ehPlanoFree" />

        <configuracao-titulo titulo="Papéis" divider-off>
            <div slot="actions" class="d-flex align-center">
                <v-slide-x-reverse-transition v-if="!ehMobile">
                    <v-text-field
                        transition="slide-x-reverse-transition"
                        v-if="mostrarSearch"
                        class="search-bar"
                        v-model="search"
                        label="Buscar pelo nome ou e-mail"
                        hide-details
                        @blur="limparFiltros"
                        @keyup.enter="atualizarFiltro"
                    />
                </v-slide-x-reverse-transition>

                <v-fade-transition>
                    <v-btn
                        v-if="!mostrarSearch || !ehMobile"
                        class="mr-4"
                        height="32px"
                        width="32px"
                        icon
                        outlined
                        @click="atualizarFiltro"
                        color="primary"
                    >
                        <v-icon> mdi-magnify</v-icon>
                    </v-btn>
                </v-fade-transition>

                <div>
                    <v-btn v-if="!ehMobile" color="primary" :disabled="ehPlanoFree" depressed @click="novoPapelOrganizacao">
                        <v-icon size="20px" class="mr-2"> mdi-plus-circle</v-icon>
                        Adicionar
                    </v-btn>

                    <v-btn v-else icon color="primary" height="32px" width="32px" @click="novoPapelOrganizacao">
                        <v-icon size="41px"> mdi-plus-circle</v-icon>
                    </v-btn>
                </div>
            </div>
        </configuracao-titulo>

        <div class="d-flex status-btns items-center pt-3">
            <button
                v-for="status in statusDisponiveis"
                :class="ehStatusSelecionado(status) ? 'active' : ''"
                @click="selecionarStatus(status)"
                :key="status"
            >
                {{ status }}
            </button>
        </div>

        <v-row no-gutters v-if="ehMobile" class="justify-space-between align-center my-4">
            <v-slide-x-reverse-transition>
                <v-text-field
                    transition="slide-x-reverse-transition"
                    v-if="mostrarSearch"
                    class="search-bar"
                    v-model="search"
                    label="Buscar pelo nome ou e-mail"
                    hide-details
                    @blur="limparFiltros"
                    @keyup.enter="atualizarFiltro"
                >
                </v-text-field>
            </v-slide-x-reverse-transition>

            <v-fade-transition>
                <v-btn v-if="mostrarSearch" class="ml-2" height="32px" width="32px" icon outlined @click="atualizarFiltro" color="primary">
                    <v-icon dark> mdi-magnify</v-icon>
                </v-btn>
            </v-fade-transition>
        </v-row>

        <v-row no-gutters class="justify-space-between mx-3 mt-5">
            <papel-tabela
                :papeis="organizacaoPapeis"
                :qtd-linhas-tabela="qtdLinhasSelecionada"
                @edit="editarPapel"
                @inativar="confirmarInativarPapel"
                @ativar="confirmarAtivarPapel"
            />
        </v-row>

        <v-row no-gutters class="justify-space-between mt-3 mx-3">
            <v-flex class="footer">
                <v-pagination
                    dense
                    class="paginas justify-center elevation-0"
                    v-model="paginacao.page"
                    :length="paginacao.numPages"
                    :total-visible="7"
                    @input="irParaPagina"
                />

                <v-spacer v-if="!ehMobile" />

                <v-select
                    v-if="!ehMobile"
                    class="linhas-por-pagina"
                    v-model="qtdLinhasSelecionada"
                    :items="quantidades"
                    label="Itens por pagina"
                    hide-details
                    @change="atualizarQtdLinhasPorPagina"
                />
            </v-flex>
        </v-row>

        <dialog-novo-papel
            v-if="abrirDialogNovoPapel"
            :dialog="abrirDialogNovoPapel"
            :organizacao-papel="organizacaoPapel"
            @fechar="fecharDialogNovoPapel"
            @salvar="salvarFecharDialogNovoPapel"
        />

        <dialog-default-confirmar-acao
            v-if="mostrarConfirmacao"
            :dialog="mostrarConfirmacao"
            sentimento="assustado"
            titulo="Eita! Deixa eu confirmar uma coisa..."
            :subtitulo="confirmacao.subtitulo"
            label-botao-principal="Sim, Claro!"
            @acao-principal="confirmacao.acaoPrincipal"
            @fechar="fecharConfirmacao"
        />
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { actionTypes } from '@/commons/constants'
import PapelTabela from './PapelTabela'
import DialogNovoPapel from './DialogNovoPapel'
import DialogDefaultConfirmarAcao from '@/commons/components/dialogs/DialogDefaultConfirmarAcao'
import ConfiguracaoTitulo from '../common/ConfiguracaoTitulo'
import ConfiguracoesExclusivas from '../common/ConfiguracoesExclusivas'

export default {
    name: 'Papel',
    components: {
        ConfiguracaoTitulo,
        DialogDefaultConfirmarAcao,
        DialogNovoPapel,
        PapelTabela,
        ConfiguracoesExclusivas,
    },
    data() {
        return {
            abrirDialogNovoPapel: false,
            organizacaoPapel: {},
            organizacaoPapeis: [],
            confirmacao: {
                subtitulo: '',
                acaoPrincipal: () => {
                    // funcao default
                },
            },
            statusDisponiveis: ['Ativos', 'Inativos', 'Todos'],
            statusSelecionado: 'Todos',
            filtros: {
                status: { value: null, default: 'Todos' },
                nome: { value: null, default: null },
            },
            paginacao: {
                page: 1,
                numPages: 0,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataCadastro',
            },
            filtrado: false,
            globalLoadingAtivado: false,
            mostrarConfirmacao: false,
            mostrarSearch: false,
            quantidades: [5, 10, 15, 25, 50],
            qtdLinhasSelecionada: 10,
            search: '',
        }
    },
    computed: {
        ...mapGetters(['ehPlanoFree']),
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        },
    },
    async mounted() {
        await this.resetarPaginacao()
        await this.resetarFiltros()
        await this.calcularNumeroLinhas()
        await this.buscarPagina()
    },
    methods: {
        abrirModalConfirmacao() {
            this.mostrarConfirmacao = true
        },
        async atualizarFiltro() {
            if (!this.mostrarSearch) {
                this.mostrarSearch = true
            } else {
                if (this.search === '') {
                    this.mostrarSearch = false
                    if (!this.filtrado) {
                        return
                    } else {
                        this.filtrado = false
                    }
                } else {
                    this.filtrado = true
                }

                this.filtros = {
                    ...this.filtros,
                    nome: { value: this.search, default: null },
                }

                await this.buscarPagina()
            }
        },
        async atualizarQtdLinhasPorPagina() {
            this.paginacao = {
                ...this.paginacao,
                page: 1,
                rowsPerPage: this.qtdLinhasSelecionada,
            }
            await this.buscarPagina()
        },
        async ativarOrganizacaoPapel() {
            this.setMensagemLoading(`Ativando o papel...`)

            await this.inativarAtivarPapel(true)

            this.organizacaoPapel = {
                id: null,
                nome: null,
            }

            this.fecharConfirmacao()
            this.fecharModalNovoPapel()
        },
        async buscarPagina() {
            const organizacoesPapeisPaginado = await this.$store.dispatch(actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.BUSCAR, {
                filtros: this.filtros,
                paginacao: this.paginacao,
            })

            this.organizacaoPapeis = organizacoesPapeisPaginado.content
            this.paginacao.numPages = organizacoesPapeisPaginado.totalPages
        },
        async calcularNumeroLinhas() {
            if (!this.ehMobile) {
                let heightBannerPlanoFree = this.ehPlanoFree ? 84 : 0
                let heightHeadersEFooters = 348
                let heightLinha = 40
                let qtdLinhasIdeal = Math.floor((window.innerHeight - heightHeadersEFooters - heightBannerPlanoFree) / heightLinha)
                this.qtdLinhasSelecionada = qtdLinhasIdeal
                this.quantidades.push(qtdLinhasIdeal)
                this.quantidades.sort(function (a, b) {
                    return a - b
                })
                await this.atualizarQtdLinhasPorPagina()
            }
        },
        async confirmarAtivarPapel(organizacaoPapel) {
            this.organizacaoPapel = {
                ...organizacaoPapel,
                id: organizacaoPapel.papelSignatarioId,
            }

            this.confirmacao = {
                subtitulo: `Você quer mesmo ativar o papel <strong>${organizacaoPapel.nome}</strong>?`,
                acaoPrincipal: this.ativarOrganizacaoPapel,
            }

            this.abrirModalConfirmacao()
        },
        confirmarInativarPapel(organizacaoPapel) {
            this.organizacaoPapel = {
                ...organizacaoPapel,
                id: organizacaoPapel.papelSignatarioId,
            }
            this.confirmacao = {
                subtitulo: `Você quer mesmo inativar o papel <strong>${organizacaoPapel.nome}</strong>?`,
                acaoPrincipal: this.inativarOrganizacaoPapel,
            }
            this.abrirModalConfirmacao()
        },
        async editarPapel(organizacaoPapel) {
            this.organizacaoPapel = {
                id: organizacaoPapel.papelSignatarioId,
                nome: organizacaoPapel.nome,
                ativo: organizacaoPapel.ativo,
            }
            this.abrirDialogNovoPapel = true
        },
        ehStatusSelecionado(status) {
            return this.statusSelecionado === status
        },
        fecharDialogNovoPapel() {
            this.abrirDialogNovoPapel = false
        },
        fecharConfirmacao() {
            this.confirmacao = {
                subtitulo: '',
                acaoPrincipal: () => {
                    // funcao default
                },
            }
            this.mostrarConfirmacao = false
        },
        fecharModalNovoPapel() {
            this.abrirDialogNovoPapel = false
        },
        async limparFiltros() {
            if (this.filtrado && this.search === '') {
                this.filtrado = false

                this.resetarFiltros()
                await this.buscarPagina()
            }
        },
        async novoPapelOrganizacao() {
            this.organizacaoPapel = {
                id: null,
                nome: null,
            }
            this.abrirDialogNovoPapel = true
        },
        resetarFiltros() {
            this.filtros = {
                status: { value: null, default: 'Todos' },
                nome: { value: null, default: null },
            }
        },
        resetarPaginacao() {
            this.paginacao = {
                page: 1,
                numPages: 0,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataCadastro',
            }
        },
        async salvarFecharDialogNovoPapel() {
            this.abrirDialogNovoPapel = false
            this.organizacaoPapel = {
                id: null,
                nome: null,
            }
            await this.buscarPagina()
        },
        async selecionarStatus(status) {
            this.statusSelecionado = status
            this.filtros.status.value = status
            await this.buscarPagina()
        },
        async inativarOrganizacaoPapel() {
            this.setMensagemLoading('Inativando o papel...')

            await this.inativarAtivarPapel(false)

            this.organizacaoPapel = {
                id: null,
                nome: null,
            }

            this.fecharConfirmacao()
            this.fecharModalNovoPapel()
        },
        async inativarAtivarPapel(ativo) {
            try {
                await this.$store.dispatch(actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.EDITAR, {
                    papelId: this.organizacaoPapel.id,
                    payload: {
                        nome: this.organizacaoPapel.nome,
                        ativo,
                    },
                })

                await this.buscarPagina()
                this.mostrarNotificacaoSucessoDefault()
            } catch {
                this.fecharConfirmacao()
            }
        },
        async irParaPagina(pagina) {
            this.paginacao.page = pagina

            await this.buscarPagina()
        },
    },
}
</script>

<style lang="stylus">
.co-papeis
    background-color var(--background-100) !important
    width 100%

    .titulo
        height 44px

    .title
        color var(--primary)

    .search-bar
        padding-top 0
        margin-top 0
        max-width 350px
        min-width 220px

    .status-btns
        width 100%
        justify-content flex-end
        gap 20px

        button
            font-size 14px
            color var(--text-color-200)

            &.active
                color var(--primary)

    .footer
        display flex
        position relative
        align-content space-between

        .paginas
            width 100%
            align-content center

        .linhas-por-pagina
            position absolute
            right 0
            width 100px

@media (max-width: 720px)
    .co-papeis
        .footer
            .linhas-por-pagina
                position unset
</style>
